import React from 'react'
import { Eye } from 'lucide-react'

const icon = props => <Eye size={20} {...props} />

export default icon
